const InvoiceConfig = () => import(/*webpackChunkName:'operation'*/'@/page/invoice/invoice-config/invoice-config.vue')
const InvoiceRecord = () => import(/*webpackChunkName:'operation'*/'@/page/invoice/invoice-record/invoice-record.vue')
const OrderDetail = () => import(/*webpackChunkName:'operation'*/'@/page/invoice/order-detail/order-detail.vue')
const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const invoice=
    {
        path: '/main/invoice',
        name: '发票管理',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [
            {
                path: '/main/invoice/config',
                name: '发票配置',
                meta: {
                    requireAuth: true,
                },
                component: InvoiceConfig
            },
            {
                path: '/main/invoice/record',
                name: '发票记录',
                meta: {
                    requireAuth: true,
                },
                component: InvoiceRecord
            },
            {
                path: '/main/invoice/order-detail',
                name: '订单详情',
                meta: {
                    requireAuth: true,
                },
                component: OrderDetail
            }
        ]
    }
